var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v("Template Usage Report")]),_c('v-card-subtitle',[_c('input-form')],1),_c('v-card-text',[_c('unit-data-table',{staticClass:"my-12"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }